export const getTooltipVerification = (isClient: boolean, isVerification: boolean) => {
  if (isClient) {
    return isVerification
      ? 'This user has confirmed their account'
      : 'User has not confirmed the account'
  }
  return isVerification
    ? `You've confirmed your e-mail`
    : 'Please, confirm your email'
}
